import React, { forwardRef } from 'react';

import { useOnMount } from '../../hooks/useOnMount';
import { SwitchType } from '../../hooks/useSwitch';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper';

interface ContentSizeSwitcherProps {
  ref?: React.Ref<HTMLDivElement>;
  isSmallModal: boolean;
  children?: React.ReactNode;
  panelVisibility: SwitchType;
}
export const ContentSizeSwitcher = forwardRef(
  ({ isSmallModal, children, panelVisibility }: ContentSizeSwitcherProps, ref: React.Ref<HTMLDivElement>) => {
    // If panel is closed, we want to show it again if an item is changed
    useOnMount(() => {
      panelVisibility?.turnOn();
    });

    if (isSmallModal) {
      return (
        <div className="content-panel__small">
          <ContentWrapper.ContentPanel
            ref={ref}
            showToggleButton
            expanded={panelVisibility.isOn}
            onExpand={panelVisibility.turnOn}
            onHide={panelVisibility.turnOff}
            appear={!panelVisibility.isOn}
          >
            {children}
          </ContentWrapper.ContentPanel>
        </div>
      );
    }
    return <div className='content-panel__fullscreen'>{children}</div>;
  }
);
